import React, { useState, useEffect } from "react";

function FrontendApplicationForm() {
  const [formData, setFormData] = useState({
    "entry.867900087": "", // Name
    "entry.588317417": "", // Phone
    "entry.136761178": "", // Email
    "entry.1301256028": "", // Gender
    "entry.101729416": "", // Resume GDrive link
    "entry.402936287": "", // LinkedIn
    "entry.1364936492": "", // Degree
    "entry.1426638677": "", // Portfolio
    "entry.1694485192": "", // Work experience years
    "entry.548287102": "No", // Currently working or not
    "entry.1655002014": "", // Current company
    "entry.1174408928": "", // Job title
    "entry.1198928712": "", // Responsibilities
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Clear error when field is edited
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const validateGDriveLink = (url) => {
    const gdrivePattern = /^https:\/\/drive\.google\.com\/.+/;
    return gdrivePattern.test(url);
  };

  const validateForm = () => {
    const newErrors = {};

    // Required fields validation
    if (!formData["entry.867900087"])
      newErrors["entry.867900087"] = "Name is required";
    if (!formData["entry.588317417"])
      newErrors["entry.588317417"] = "Phone is required";
    if (!formData["entry.136761178"])
      newErrors["entry.136761178"] = "Email is required";
    if (!formData["entry.1301256028"])
      newErrors["entry.1301256028"] = "Gender is required";
    if (!formData["entry.101729416"]) {
      newErrors["entry.101729416"] = "Resume link is required";
    } else if (!validateGDriveLink(formData["entry.101729416"])) {
      newErrors["entry.101729416"] = "Please provide a valid Google Drive link";
    }

    // Conditional validation for currently employed
    if (formData["entry.548287102"] === "Yes") {
      if (!formData["entry.1655002014"])
        newErrors["entry.1655002014"] = "Current company is required";
      if (!formData["entry.1174408928"])
        newErrors["entry.1174408928"] = "Job title is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    // Create a temporary visible form
    const form = document.createElement("form");
    form.action =
      "https://docs.google.com/forms/d/e/1FAIpQLSe1K1Rj7Svdkkc1zEB_BOYbkIKHTyHTEUnnXu492zY1Mk78DQ/formResponse";
    form.method = "POST";
    form.target = "_blank"; // Opens in new tab
    form.style.display = "block"; // Make it visible

    // Add all form data
    Object.entries(formData).forEach(([key, value]) => {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = key;
      input.value = value;
      form.appendChild(input);
    });

    document.body.appendChild(form);
    form.submit();
    setFormData({
      "entry.867900087": "",
      "entry.588317417": "",
      "entry.136761178": "",
      "entry.1301256028": "",
      "entry.101729416": "",
      "entry.402936287": "",
      "entry.1364936492": "",
      "entry.1426638677": "",
      "entry.1694485192": "",
      "entry.548287102": "No",
      "entry.1655002014": "",
      "entry.1174408928": "",
      "entry.1198928712": "",
    });
    // Show confirmation after a delay
    setTimeout(() => {
      document.body.removeChild(form);
    }, 1000);
  };

  return (
    <div className="max-w-2xl mx-auto p-6 bg-secondary-light dark:bg-tertiary-dark rounded-lg shadow-md min-h-screen mt-32">
      <h1 className="text-2xl font-bold text-gray-800 dark:text-white mb-6">
        Application Form
      </h1>

      <form onSubmit={handleSubmit} className="space-y-6">
        {/* Personal Information Section */}
        <div className="space-y-4">
          <h2 className="text-xl font-semibold text-custom-dark dark:text-custom-grey border-b pb-2">
            Personal Information
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label
                htmlFor="entry.867900087"
                className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1"
              >
                Full Name *
              </label>
              <input
                type="text"
                id="entry.867900087"
                name="entry.867900087"
                value={formData["entry.867900087"]}
                onChange={handleChange}
                required
                className={`w-full px-4 py-2 border rounded-md focus:ring-2 focus:ring-sustally-violet focus:border-sustally-violet dark:bg-custom-grey dark:!text-custom-dark ${
                  errors["entry.867900087"]
                    ? "border-red-500"
                    : "border-gray-300 dark:border-gray-600"
                }`}
              />
              {errors["entry.867900087"] && (
                <p className="mt-1 text-sm text-red-600">
                  {errors["entry.867900087"]}
                </p>
              )}
            </div>

            <div>
              <label
                htmlFor="entry.588317417"
                className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1"
              >
                Phone Number *
              </label>
              <input
                type="tel"
                id="entry.588317417"
                name="entry.588317417"
                value={formData["entry.588317417"]}
                onChange={handleChange}
                required
                className={`w-full px-4 py-2 border rounded-md focus:ring-2 focus:ring-sustally-violet focus:border-sustally-violet dark:bg-custom-grey dark:!text-custom-dark ${
                  errors["entry.588317417"]
                    ? "border-red-500"
                    : "border-gray-300 dark:border-gray-600"
                }`}
              />
              {errors["entry.588317417"] && (
                <p className="mt-1 text-sm text-red-600">
                  {errors["entry.588317417"]}
                </p>
              )}
            </div>
          </div>

          <div>
            <label
              htmlFor="entry.136761178"
              className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1"
            >
              Email Address *
            </label>
            <input
              type="email"
              id="entry.136761178"
              name="entry.136761178"
              value={formData["entry.136761178"]}
              onChange={handleChange}
              required
              className={`w-full px-4 py-2 border rounded-md focus:ring-2 focus:ring-sustally-violet focus:border-sustally-violet dark:bg-custom-grey dark:!text-custom-dark ${
                errors["entry.136761178"]
                  ? "border-red-500"
                  : "border-gray-300 dark:border-gray-600"
              }`}
            />
            {errors["entry.136761178"] && (
              <p className="mt-1 text-sm text-red-600">
                {errors["entry.136761178"]}
              </p>
            )}
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
                Gender *
              </label>
              <div className="flex space-x-4">
                <label className="inline-flex items-center">
                  <input
                    type="radio"
                    name="entry.1301256028"
                    value="Male"
                    checked={formData["entry.1301256028"] === "Male"}
                    onChange={handleChange}
                    className="text-sustally-violet focus:ring-sustally-violet"
                  />
                  <span className="ml-2 text-gray-700 dark:text-gray-300">
                    Male
                  </span>
                </label>
                <label className="inline-flex items-center">
                  <input
                    type="radio"
                    name="entry.1301256028"
                    value="Female"
                    checked={formData["entry.1301256028"] === "Female"}
                    onChange={handleChange}
                    className="text-sustally-violet focus:ring-sustally-violet"
                  />
                  <span className="ml-2 text-gray-700 dark:text-gray-300">
                    Female
                  </span>
                </label>
                <label className="inline-flex items-center">
                  <input
                    type="radio"
                    name="entry.1301256028"
                    value="Other"
                    checked={formData["entry.1301256028"] === "Other"}
                    onChange={handleChange}
                    className="text-sustally-violet focus:ring-sustally-violet"
                  />
                  <span className="ml-2 text-gray-700 dark:text-gray-300">
                    Other
                  </span>
                </label>
              </div>
              {errors["entry.1301256028"] && (
                <p className="mt-1 text-sm text-red-600">
                  {errors["entry.1301256028"]}
                </p>
              )}
            </div>

            <div>
              <label
                htmlFor="entry.1694485192"
                className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1"
              >
                Work Experience (Years)
              </label>
              <input
                type="number"
                id="entry.1694485192"
                name="entry.1694485192"
                value={formData["entry.1694485192"]}
                onChange={handleChange}
                min="0"
                className="w-full px-4 py-2 border rounded-md focus:ring-2 focus:ring-sustally-violet focus:border-sustally-violet dark:bg-custom-grey dark:!text-custom-dark"
              />
            </div>
          </div>

          <div>
            <label
              htmlFor="entry.101729416"
              className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1"
            >
              Resume (Google Drive Link) *
            </label>
            <input
              type="url"
              id="entry.101729416"
              name="entry.101729416"
              value={formData["entry.101729416"]}
              onChange={handleChange}
              placeholder="https://drive.google.com/..."
              className={`w-full px-4 py-2 border rounded-md focus:ring-2 focus:ring-sustally-violet focus:border-sustally-violet dark:bg-custom-grey dark:!text-custom-dark ${
                errors["entry.101729416"]
                  ? "border-red-500"
                  : "border-gray-300 dark:border-gray-600"
              }`}
            />
            {errors["entry.101729416"] && (
              <p className="mt-1 text-sm text-red-600">
                {errors["entry.101729416"]}
              </p>
            )}
            <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
              Please upload your resume to Google Drive and share the link
            </p>
          </div>
        </div>

        {/* Professional Information Section */}
        <div className="space-y-4">
          <h2 className="text-xl font-semibold text-gray-700 dark:text-gray-300 border-b pb-2">
            Professional Information
          </h2>

          <div>
            <label
              htmlFor="entry.402936287"
              className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1"
            >
              LinkedIn Profile
            </label>
            <input
              type="url"
              id="entry.402936287"
              name="entry.402936287"
              value={formData["entry.402936287"]}
              onChange={handleChange}
              placeholder="https://linkedin.com/in/yourprofile"
              className="w-full px-4 py-2 border rounded-md focus:ring-2 focus:ring-sustally-violet focus:border-sustally-violet dark:bg-custom-grey dark:!text-custom-dark"
            />
          </div>

          <div>
            <label
              htmlFor="entry.1364936492"
              className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1"
            >
              Highest Degree *
            </label>
            <select
              id="entry.1364936492"
              name="entry.1364936492"
              value={formData["entry.1364936492"]}
              onChange={handleChange}
              className="w-full px-4 py-2 border rounded-md focus:ring-2 focus:ring-sustally-violet focus:border-sustally-violet dark:bg-custom-grey dark:!text-custom-dark"
              required
            >
              <option value="">Select your degree</option>
              <option value="B.Tech">B.Tech</option>
              <option value="B.E.">B.E.</option>
              <option value="B.Sc">B.Sc</option>
              <option value="B.Com">B.Com</option>
              <option value="BBA">BBA</option>
              <option value="MBA">MBA</option>
              <option value="MCA">MCA</option>
              <option value="M.Tech">M.Tech</option>
              <option value="Other">Other</option>
            </select>
          </div>

          <div>
            <label
              htmlFor="entry.1426638677"
              className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1"
            >
              Portfolio/Website
            </label>
            <input
              type="url"
              id="entry.1426638677"
              name="entry.1426638677"
              value={formData["entry.1426638677"]}
              onChange={handleChange}
              placeholder="https://yourportfolio.com"
              className="w-full px-4 py-2 border rounded-md focus:ring-2 focus:ring-sustally-violet focus:border-sustally-violet dark:bg-custom-grey dark:!text-custom-dark"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
              Are you currently employed? *
            </label>
            <div className="flex space-x-4">
              <label className="inline-flex items-center">
                <input
                  type="radio"
                  name="entry.548287102"
                  value="Yes"
                  checked={formData["entry.548287102"] === "Yes"}
                  onChange={handleChange}
                  className="text-sustally-violet focus:ring-sustally-violet"
                />
                <span className="ml-2 text-gray-700 dark:text-gray-300">
                  Yes
                </span>
              </label>
              <label className="inline-flex items-center">
                <input
                  type="radio"
                  name="entry.548287102"
                  value="No"
                  checked={formData["entry.548287102"] === "No"}
                  onChange={handleChange}
                  className="text-sustally-violet focus:ring-sustally-violet"
                />
                <span className="ml-2 text-gray-700 dark:text-gray-300">
                  No
                </span>
              </label>
            </div>
          </div>

          {formData["entry.548287102"] === "Yes" && (
            <div className="space-y-4 bg-tertiary-light dark:bg-custom-dark p-4 rounded-md">
              <h3 className="font-medium text-gray-700 dark:text-gray-300">
                Current Employment Details
              </h3>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label
                    htmlFor="entry.1655002014"
                    className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1"
                  >
                    Current Company *
                  </label>
                  <input
                    type="text"
                    id="entry.1655002014"
                    name="entry.1655002014"
                    value={formData["entry.1655002014"]}
                    onChange={handleChange}
                    className={`w-full px-4 py-2 border rounded-md focus:ring-2 focus:ring-sustally-violet focus:border-sustally-violet dark:bg-custom-grey dark:!text-custom-dark ${
                      errors["entry.1655002014"]
                        ? "border-red-500"
                        : "border-gray-300 dark:border-gray-600"
                    }`}
                  />
                  {errors["entry.1655002014"] && (
                    <p className="mt-1 text-sm text-red-600">
                      {errors["entry.1655002014"]}
                    </p>
                  )}
                </div>

                <div>
                  <label
                    htmlFor="entry.1174408928"
                    className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1"
                  >
                    Job Title *
                  </label>
                  <input
                    type="text"
                    id="entry.1174408928"
                    name="entry.1174408928"
                    value={formData["entry.1174408928"]}
                    onChange={handleChange}
                    className={`w-full px-4 py-2 border rounded-md focus:ring-2 focus:ring-sustally-violet focus:border-sustally-violet dark:bg-custom-grey dark:!text-custom-dark ${
                      errors["entry.1174408928"]
                        ? "border-red-500"
                        : "border-gray-300 dark:border-gray-600"
                    }`}
                  />
                  {errors["entry.1174408928"] && (
                    <p className="mt-1 text-sm text-red-600">
                      {errors["entry.1174408928"]}
                    </p>
                  )}
                </div>
              </div>

              <div>
                <label
                  htmlFor="entry.1198928712"
                  className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1"
                >
                  Responsibilities & Achievements
                </label>
                <textarea
                  id="entry.1198928712"
                  name="entry.1198928712"
                  value={formData["entry.1198928712"]}
                  onChange={handleChange}
                  rows={4}
                  className="w-full px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-md focus:ring-2 focus:ring-sustally-violet focus:border-sustally-violet dark:bg-custom-grey dark:!text-custom-dark"
                  placeholder="Describe your key responsibilities and achievements in this role"
                />
              </div>
            </div>
          )}
        </div>

        <div className="flex justify-end">
          <button
            type="submit"
            className={`px-6 py-2 bg-sustally-violet text-white font-medium rounded-full hover:bg-sustally-violet/80`}
          >
            Submit Application
          </button>
        </div>
      </form>
    </div>
  );
}

export default FrontendApplicationForm;
